import QueryString from "qs";
import qs from "qs";
import mainAxios from "../api/mainAxios";
import toast from "react-hot-toast";

export const setActiveOnglet = (onglet) => ({
  type: "SET_ACTIVE_ONGLET",
  payload: onglet,
});

export const setActiveView = (view) => ({
  type: "SET_ACTIVE_VIEW",
  payload: view,
});

export const setSingleProgramId = (id) => ({
  type: "SET_SINGLE_PROGRAM_ID",
  payload: id,
});

export const addOpenProgram = (documentId) => ({
  type: "ADD_OPEN_PROGRAM",
  payload: documentId,
});

export const removeOpenProgram = (documentId) => ({
  type: "REMOVE_OPEN_PROGRAM",
  payload: documentId,
});

export const setCurrentPage = (page) => ({
  type: "SET_CURRENT_PAGE",
  payload: page,
});

export const setSingleLotId = (id) => ({
  type: "SET_SINGLE_LOT_ID",
  payload: id,
});

export const addOpenLot = (documentId) => ({
  type: "ADD_OPEN_LOT",
  payload: documentId,
});

export const removeOpenLot = (documentId) => ({
  type: "REMOVE_OPEN_LOT",
  payload: documentId,
});

export const fetchProgrammes = (
  page = 1,
  pageSize = 25,
  sort = "updatedAt",
  search = "",
  direction = "desc"
) => {
  return async (dispatch) => {
    dispatch({ type: "FETCH_PROGRAMMES_REQUEST" });

    const queryObj = {
      sort: [`${sort}:${direction}`],
      populate: {
        lots: {
          sort: ["price_total:asc"],
          populate: {
            images: {
              populate: { image: { fields: ["url"] } },
            },
            programme_parent: { fields: ["*"] },

            documents_pdfs: {
              populate: { document: { fields: ["url"] } },
            },
          },
        },
        promoteur: { fields: ["*"] },
        city: { fields: ["*"] },
      },
      filters: {
        lots: {
          $notNull: true,
          $ne: [],
        },
      },
    };

    // Create the query string with the _q parameter if search is provided
    const query = qs.stringify(queryObj);
    try {
      let url = `api/programmes?${query}&pagination[page]=${page}&pagination[pageSize]=${pageSize}`;

      // Add the _q parameter if search is provided
      if (search && search.trim() !== "") {
        url += `&_q=${encodeURIComponent(search)}`;
      }

      const response = await mainAxios.get(url);

      dispatch({
        type: "FETCH_PROGRAMMES_SUCCESS",
        payload: {
          programmes: response.data.data,
          pagination: response.data.meta.pagination,
        },
      });
    } catch (error) {
      dispatch({
        type: "FETCH_PROGRAMMES_FAILURE",
        payload: error.message,
      });
    }
  };
};

export const fetchSingleProgram = (programmeId) => {
  return async (dispatch) => {
    dispatch({ type: "FETCH_SINGLE_PROGRAM_REQUEST" });

    const query = QueryString.stringify({
      populate: {
        lots: {
          populate: {
            geo_orientations: true,
            disponibility: { fields: ["disponibilite"] },
            images: {
              populate: { image: { fields: ["url"] } },
            },
            programme_parent: { fields: ["*"] },

            documents_pdfs: {
              populate: { document: { fields: ["url"] } },
            },
            project_types: true,
          },
        },
        promoteur: {
          populate: {
            promoteur_accesses: {
              fields: ["documentId", "login", "password"],
              populate: {
                secteur: {
                  fields: ["name", "id", "documentId"],
                  populate: {
                    users: {
                      fields: ["*"],
                      populate: {
                        profile_image: { fields: ["url"] },
                      },
                    },
                  },
                },
              },
            },
          },
        },
        documents_pdfs: {
          populate: { document: { fields: ["url"] } },
        },
      },
    });

    try {
      const response = await mainAxios.get(
        `api/programmes/${programmeId}?${query}`
      );

      dispatch({
        type: "FETCH_SINGLE_PROGRAM_SUCCESS",
        payload: response.data.data,
      });
    } catch (error) {
      dispatch({
        type: "FETCH_SINGLE_PROGRAM_FAILURE",
        payload: error.message,
      });
    }
  };
};

export const fetchLots = (
  page = 1,
  pageSize = 25,
  sort = "updatedAt",
  search = "",
  direction = "desc"
) => {
  return async (dispatch) => {
    dispatch({ type: "FETCH_LOTS_REQUEST" });

    try {
      const queryObj = {
        sort: [`${sort}:${direction}`],
        populate: {
          documents_pdfs: {
            populate: {
              document: {
                fields: ["url"],
              },
            },
          },
          images: {
            populate: {
              image: {
                fields: ["url"],
              },
            },
          },
          project_types: true,
          programme_parent: true,
          disponibility: true,
        },
        pagination: {
          page,
          pageSize,
        },
      };

      const query = QueryString.stringify(queryObj, { encode: false });

      let url = `api/lots?${query}`;

      // Add the _q parameter if search is provided
      if (search && search.trim() !== "") {
        // Use filters with $or to search in both default fields and programme_parent.name
        const filterObj = {
          filters: {
            $or: [
              // String fields
              { reference: { $containsi: search } },
              { typology: { $containsi: search } },
              { type: { $containsi: search } },
              { commission: { $containsi: search } },
              { availability: { $containsi: search } },
              { floor: { $containsi: search } },
              { original_id: { $containsi: search } },
              { origine: { $containsi: search } },
              { selfLink: { $containsi: search } },

              // Numeric fields - only applied if search is a valid number
              ...(isNaN(Number(search))
                ? []
                : [
                    { surface: { $eq: Number(search) } },
                    { price_total: { $eq: Number(search) } },
                    { rent: { $eq: Number(search) } },
                    { rent_profitability: { $eq: Number(search) } },
                    { weighted_surface: { $eq: Number(search) } },
                    { price_vat_rate: { $eq: Number(search) } },
                    { parking_price_incl_tax: { $eq: Number(search) } },
                    { price_excl_vat: { $eq: Number(search) } },
                    { parking_price_excl_vat: { $eq: Number(search) } },
                    { price_incl_tax: { $eq: Number(search) } },
                    { parking_price_vat_rate: { $eq: Number(search) } },
                    { parking_count: { $eq: Number(search) } },
                    { global_score: { $eq: Number(search) } },
                  ]),

              // Relation field
              { programme_parent: { name: { $containsi: search } } },
            ],
          },
        };

        const filterQuery = QueryString.stringify(filterObj, { encode: false });
        url += `&${filterQuery}`;
      }
      const response = await mainAxios.get(url);

      dispatch({
        type: "FETCH_LOTS_SUCCESS",
        payload: {
          lots: response.data.data,
          pagination: response.data.meta.pagination,
        },
      });
    } catch (error) {
      dispatch({
        type: "FETCH_LOTS_FAILURE",
        payload: error.message,
      });
    }
  };
};

export const fetchSingleLot = (documentId) => {
  return async (dispatch) => {
    dispatch({
      type: "FETCH_SINGLE_LOT_REQUEST",
      payload: documentId,
    });

    const query = QueryString.stringify({
      populate: {
        images: {
          populate: { image: { fields: ["url"] } },
        },
        programme_parent: {
          populate: {
            lots: {
              populate: {
                images: {
                  populate: { image: { fields: ["url"] } },
                },
              },
            },
            promoteur: true,
          },
        },
        documents_pdfs: {
          populate: "*",
        },
        project_types: {
          populate: "*",
        },
        geo_orientations: { fields: ["orientation", "documentId"] },
      },
    });

    try {
      const response = await mainAxios.get(`api/lots/${documentId}?${query}`);

      const lotData = {
        ...response.data.data,
        id: documentId,
      };

      dispatch({
        type: "FETCH_SINGLE_LOT_SUCCESS",
        payload: lotData,
      });

      return lotData;
    } catch (error) {
      dispatch({
        type: "FETCH_SINGLE_LOT_FAILURE",
        payload: error.message,
        meta: { documentId },
      });
      throw error;
    }
  };
};

export const deepSearchFunction = (formData) => {
  return async (dispatch) => {
    dispatch({ type: "DEEP_SEARCH_LOADING" });

    try {
      // Transform formData into query parameters
      const queryParams = {};

      // General section
      if (formData.usage) queryParams.usage = formData.usage;
      if (formData.lieu) queryParams.lieu = formData.lieu;
      if (formData.dispositif) queryParams.dispositif = formData.dispositif;
      if (formData.zoneFiscale) queryParams.zoneFiscale = formData.zoneFiscale;
      if (formData.statutLot) queryParams.statutLot = formData.statutLot;
      if (formData.dateDajout) queryParams.dateDajout = formData.dateDajout;
      if (formData.natureMandat)
        queryParams.natureMandat = formData.natureMandat;

      // Economic section
      if (formData.budgetMin) queryParams.budgetMin = formData.budgetMin;
      if (formData.budgetMax) queryParams.budgetMax = formData.budgetMax;
      if (formData.prixM2Min) queryParams.prixM2Min = formData.prixM2Min;
      if (formData.prixM2Max) queryParams.prixM2Max = formData.prixM2Max;
      if (formData.rentabilite)
        queryParams.rentabilite = formData.rentabilite / 100;
      if (formData.honoraires) queryParams.honoraires = formData.honoraires;

      // Lot section
      if (formData.referenceLot)
        queryParams.referenceLot = formData.referenceLot;
      if (formData.nature) queryParams.nature = formData.nature;
      if (formData.surfaceMin) queryParams.surfaceMin = formData.surfaceMin;
      if (formData.surfaceMax) queryParams.surfaceMax = formData.surfaceMax;
      if (formData.espaceTotalMin)
        queryParams.espaceTotalMin = formData.espaceTotalMin;
      queryParams.espaceTotalMax = formData.espaceTotalMax;
      if (formData.typologieLot)
        queryParams.typologieLot = formData.typologieLot;
      if (formData.etage) queryParams.etage = formData.etage;
      if (formData.annexe) queryParams.annexe = formData.annexe;

      // Programme section
      if (formData.programmeParent)
        queryParams.programmeParent = formData.programmeParent;
      if (formData.promoteur) queryParams.promoteur = formData.promoteur;
      if (formData.dateDajoutProgramme)
        queryParams.dateDajoutProgramme = formData.dateDajoutProgramme;
      if (formData.tag) queryParams.tag = formData.tag;
      if (formData.label) queryParams.label = formData.label;
      if (formData.lotMaximum) queryParams.lotMaximum = formData.lotMaximum;

      const query = QueryString.stringify(queryParams);

      // Make the API call to the custom endpoint
      const response = await mainAxios.get(
        `/api/deep-search-properties?${query}`
      );

      dispatch({
        type: "DEEP_SEARCH_SUCCESS",
        payload: response.data.data,
      });

      if (response.data.data.length == 0) {
        toast.error("Aucun résultat trouvé");
        dispatch({
          type: "DEEP_SEARCH_FAILURE",
          payload: "Aucun résultat trouvé",
        });
        return;
      }
    } catch (error) {
      console.error("Advanced search error:", error);
      dispatch({
        type: "DEEP_SEARCH_FAILURE",
        payload: error.message || "Failed to execute search",
      });
    }
  };
};

export const closeSearch = () => {
  return {
    type: "CLOSE_SEARCH",
  };
};
